export const googleClientId = process.env.REACT_APP_CLUBHOUSE_GOOGLE_CLIENT_ID?.trim() ?? '';

export const googleConfigured = googleClientId.length > 0;